module.exports = __webpack_public_path__ + "static/media/0325_IMG_LE_BOUCHER.1479be46.webp";